import { Plan, PlanExtraComposite } from '@dtx-company/true-common/src/types/Plan'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { Subscription } from '@dtx-company/inter-app/src/types/subscription'
import { usePlanPurchaseExperienceExtraComposites } from '@app/common/src/components/PlanPurchaseExperience/hooks/usePlanPurchaseExperienceExtraComposites'

interface BuyPlanPagePlanExtrasProps {
  planType?: PlanType
  currentSubscriptionInfoData?: Subscription | null | undefined
  selectedPlan?: Plan
}

export function useBuyPlanPagePlanExtras({
  planType,
  currentSubscriptionInfoData,
  selectedPlan
}: BuyPlanPagePlanExtrasProps): PlanExtraComposite[] | undefined {
  const currentPlanExtraDetails =
    planType &&
    currentSubscriptionInfoData?.plan.type === planType &&
    currentSubscriptionInfoData.planExtraDetails.length
      ? currentSubscriptionInfoData.planExtraDetails
      : undefined

  const planExtras = usePlanPurchaseExperienceExtraComposites(
    selectedPlan?.planExtras,
    currentPlanExtraDetails
  )
  return planExtras
}
